<template>
  <div class="gyzhmain">
    <!-- 大图 -->
    <div class="bigbgi">
      <div class="midbgi">
      </div>
    </div>
    <div class="gyzgcont">

      <el-row>
        <el-col :span="24">
          <div class="bread">
            <div>
              <a href="https://www.ciepec-online.com:8086/"> 首页>></a>
            </div>
            <div>联系我们>></div>
          </div>
          <div v-if="menuName=='联系我们'||pageNum==1">
            <div style="padding:40px 80px; background-color:#fff;border-radius:8px;box-shadow:0 2px 12px rgba(0,0,0,0.05);margin-top:20px">
              <div style="font-size:32px;color:#0c68a3;margin-bottom:30px;font-weight:700;text-align:center">联系我们</div>
              <div style="border-bottom:3px solid #159a7e;width:100px;margin:0 auto 40px auto"></div>

              <div style="max-width:800px;margin:0 auto">
                <div style="margin-bottom:40px">
                  <div style="font-size:20px;color:#000;margin-bottom:25px;font-weight:600;background-color:#f0f8ff;padding:10px 20px;border-left:5px solid #159a7e">国内企业请联系：</div>
                  <div style="margin-bottom:20px;padding-left:30px;">
                    <span style="font-weight:500;color:#333;font-size:16px;display:inline-block;width:100px">单位名称：</span>
                    <span style="color:#666;font-size:16px">中国环境保护产业协会</span>
                  </div>
                  <div style="margin-bottom:20px;padding-left:30px;">
                    <span style="font-weight:500;color:#333;font-size:16px;display:inline-block;width:100px">地址：</span>
                    <span style="color:#666;font-size:16px">北京市西城区二七剧场路6号</span>
                  </div>
                  <div style="margin-bottom:20px;padding-left:30px;">
                    <span style="font-weight:500;color:#333;font-size:16px;display:inline-block;width:100px">E-mail：</span>
                    <span style="color:#666;font-size:16px">intl@caepi.org.cn</span>
                  </div>
                </div>

                <div style="margin-bottom:40px">
                  <div style="font-size:20px;color:#000;margin-bottom:25px;font-weight:600;background-color:#f0f8ff;padding:10px 20px;border-left:5px solid #159a7e">企业参展报名联系人：</div>
                  <div style="margin-bottom:20px;padding-left:30px;">
                    <span style="font-weight:500;color:#333;font-size:16px;display:inline-block;width:100px">咨询电话：</span>
                    <span style="color:#666;font-size:16px">010-52806519</span>
                  </div>
                  <div style="margin-bottom:15px;padding-left:130px;">
                    <span style="color:#666;font-size:16px">孟骁</span>
                  </div>
                  <div style="margin-bottom:15px;padding-left:130px;">
                    <span style="color:#666;font-size:16px">张业玲</span>
                  </div>
                  <div style="margin-bottom:15px;padding-left:130px;">
                    <span style="color:#666;font-size:16px">郑甜甜</span>
                  </div>
                </div>

                <div style="margin-bottom:20px">
                  <div style="font-size:20px;color:#000;margin-bottom:25px;font-weight:600;background-color:#f0f8ff;padding:10px 20px;border-left:5px solid #159a7e">会议联系人：</div>
                  <div style="margin-bottom:20px;padding-left:30px;">
                    <span style="font-weight:500;color:#333;font-size:16px;display:inline-block;width:100px">王睿：</span>
                    <span style="color:#666;font-size:16px">010-52806517</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>

    </div>
  </div>
</template>

<script>
export default {
  name: 'Gyzh',
  data () {
    return {
      menuName: '联系我们',
      pageNum: '1'
    }
  },
  methods: {
    handleSelect (key) {
      this.menuName = event.target.innerText.trim()
      this.pageNum = key
    }
  }
}
</script>

<style scoped>
.gyzhmain {
  width: 100%;
}
.bigbgi {
  background-image: url('../../assets/index/banner-2026.jpg');
  background-repeat: no-repeat;
  background-position: center top;
  background-size: cover;
  width: 100%;
  height: 0;
  padding-bottom: 27.87%;
  margin-bottom: 60px;
}
.midbgi {
  background-image: none;
  width: 100%;
}
.gyzgcont {
  width: 80%;
  margin: 0 auto;
}

.gyzhcd {
  background: url('../../assets/index/cebian2.png') no-repeat,
    linear-gradient(180deg, #ffffff 0%, #e4efff 100%);
  background-repeat: no-repeat;
  background-position: center bottom;
  background-size: 100%;

  width: 100%;
}
.el-menu-item {
  text-align: center;
  font-size: 18px;
  color: #16181a;
  letter-spacing: -0px;
  text-align: center;
  font-weight: 400;
}
.el-menu-item.is-active {
  font-weight: bold;
  color: #1d50a2;
}
p {
  text-align: center;
}
.cdtitle {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -80px;
  height: 86px;
  color: #fff;
  font-size: 24px;
  color: #ffffff;
  letter-spacing: 0;
  text-align: center;
  font-weight: 700;
  background-image: url('../../assets/index/cebian1.png'); /* 设置图片路径 */
  background-repeat: no-repeat; /* 背景图片不重复 */
  background-position: center; /* 背景图片居中 */
  background-size: cover;
  height: 80px; /* 元素高度 */
  /* width: 100%; */
}
.bread {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: -60px;
  opacity: 0.94;
  background-image: linear-gradient(
    90deg,
    rgba(14, 152, 121, 0) 0%,
    #0e9577 50%
  );
  height: 60px;
  width: 470px;
  float: right;
  font-size: 16px;
  color: #ffffff;
  letter-spacing: 0;
  font-weight: 500;
}
a {
  text-decoration: none;
  font-size: 16px;
  color: #fff;
}
.address {
  opacity: 0.9;
  background: #eff5ff;
  font-size: 18px;
  color: #333333;
  line-height: 34px;
  font-weight: 400;
  padding: 10px;
}
.zcsj {
  margin: 20px 0;
  padding: 10px 0;
  background: #159a7e;
  font-size: 24px;
  color: #ffffff;
  letter-spacing: 0;
  line-height: 24px;
  text-align: center;
  font-weight: 600;
}
.jt {
  /* display: flex; */
  margin: 0 auto;
  text-align: center;
}
.rqys {
  display: flex;
  /* justify-content: space-between; */
  align-items: center;
  height: 40px;
}
.greendian {
  width: 10px;
  height: 10px;
  border-radius: 10px;
  background: #159a7e;
}
.rcsj {
  flex: 1;
  font-size: 18px;
  color: #333333;
  text-align: center;
  line-height: 18px;
  font-weight: 400;
}
.xgtitle {
  width: 280px;
  margin-bottom: 10px;
  margin-top: 5px;
  overflow: hidden; /* 确保超出的内容会被裁剪 */
  white-space: nowrap; /* 确保文本在一行内显示 */
  text-overflow: ellipsis; /* 超出的文本部分显示为 省略号 */
  font-size: 18px;
  color: #333333;
  line-height: 32px;
  font-weight: 400;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .gyzgcont {
    width: 95%;
  }

  .bread {
    width: 100%;
    float: none;
    margin-top: 0;
  }

  div[style*="padding:40px 80px"] {
    padding: 20px 15px !important;
  }

  div[style*="font-size:32px"] {
    font-size: 24px !important;
  }

  div[style*="font-size:20px"] {
    font-size: 18px !important;
  }

  div[style*="max-width:800px"] {
    max-width: 100% !important;
  }

  div[style*="padding-left:130px"] {
    padding-left: 50px !important;
  }
}

@media (max-width: 480px) {
  .bigbgi, .midbgi {
    height: 200px;
  }

  div[style*="font-size:32px"] {
    font-size: 20px !important;
  }

  div[style*="padding:10px 20px"] {
    padding: 8px 15px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/caidan/lxwm.vue